import React, { Component } from "react";
import { Route, Redirect, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import Home from "./pages/home";
import Settings from "./pages/settings";

import Accounts from "./pages/accounts";
import AccountForm from "./pages/accounts/accountForm";

import Tickets from "./pages/tickets";
import TicketForm from "./pages/tickets/ticketForm";

import Payments from "./pages/payments";
import PaymentForm from "./pages/payments/paymentForm";

import Invoices from "./pages/invoices";
import Invoice360Panel from "./pages/invoices/invoice360/Invoice360Panel";

import Bonuses from "./pages/bonuses";
import Bonus360Panel from "./pages/bonuses/bonus360/Bonus360Panel";
import NotificationCenterPage from "./pages/notifications";

import NotFound from "./components/notFound";
import HelpDrawer from "./components/help/HelpDrawer";
import PortalAiWidget from "./platform/ai/PortalAiWidget";
import { HELP_OPEN_EVENT } from "./platform/help/helpOpen";
import NavBar from "./layout/navBar";
import SideNav from "./layout/sideNav";
import Footer from "./layout/footer";
import ConnectivityBanner from "./components/common/connectivityBanner";
import ConnectivityProbe from "./components/common/connectivityProbe";

import LoginForm from "./pages/auth/login";
import ForgotPasswordForm from "./pages/auth/forgotPassword";
import ResetPasswordForm from "./pages/auth/resetPassword";
import Logout from "./pages/auth/logout";
import ProtectedRoute from "./components/common/protectedRoute";
import auth from "./services/authService";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";

class App extends Component {
  state = {
    showSideBar: true,
    isHelpOpen: false,
    helpDocPath: null,
  };

  componentDidMount() {
    window.addEventListener(HELP_OPEN_EVENT, this.onHelpOpenEvent);
    const user = auth.getCurrentUser();
    this.setState({ user });
  }

  componentWillUnmount() {
    window.removeEventListener(HELP_OPEN_EVENT, this.onHelpOpenEvent);
  }

  handleNavButtonClick () {
    let showSideBar = this.state.showSideBar;
    showSideBar = !showSideBar;
    this.setState({showSideBar});
  }

  onHelpOpenEvent = (ev) => {
    const detail = (ev && ev.detail) || {};
    this.setState({
      isHelpOpen: true,
      helpDocPath: detail.docPath || null,
    });
  };

  openHelp = () => {
    this.setState({ isHelpOpen: true, helpDocPath: null });
  };

  closeHelp = () => {
    this.setState({ isHelpOpen: false, helpDocPath: null });
  };

  render() {
    const { user } = this.state;

    return (
      <React.Fragment>
        {/* <ToastContainer /> */}
        <ToastContainer 
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <div className="mboss-app-shell">
          <ConnectivityProbe />
          { user && <NavBar user={user} onHelpOpen={this.openHelp} /> }
          <ConnectivityBanner />
          <main className="container mboss-app-main">
            <div className="row m-0 flex py-2">
              {/* { user && 
                <span
                  className="d-none d-md-block m-0"
                  onClick={() => {this.handleNavButtonClick()}}
                  style={{ cursor: "pointer" }}
                >
                  { !this.state.showSideBar && <i className="fa fa-bars fa-xs text-secondary" /> }
                  { this.state.showSideBar && <i className="fa fa-close fa-xs text-secondary" /> }
                </span>
              } */}
              {user && this.state.showSideBar &&
                <div className="col-lg-3 d-none d-md-block">
                  <SideNav user={user} />
                </div>
              }
              <div className="col">
                <Switch>
                {/* {!user && <Redirect to="/login" />} */}

                <Route exact path="/login" component={LoginForm} />
                <Route exact path="/forgot-password" component={ForgotPasswordForm} />
                <Route exact path="/reset-password" component={ResetPasswordForm} />
                <Route exact path="/logout" component={Logout} />

                <ProtectedRoute 
                  exact path="/home" 
                  render={props => <Home {...props} user={user} />}
                />
                <ProtectedRoute 
                  path="/settings" 
                  render={props => <Settings {...props} user={user} />}
                />
                <ProtectedRoute
                  path="/notifications"
                  render={props => <NotificationCenterPage {...props} user={user} />}
                />

                <ProtectedRoute
                  path="/accounts/:id"
                  render={props => <AccountForm {...props} user={user} />}
                />
                <ProtectedRoute
                  path="/accounts"
                  render={props => <Accounts {...props} user={user} />}
                />

                <ProtectedRoute
                  path="/tickets/:id"
                  render={props => <TicketForm {...props} user={user} />}
                />
                <ProtectedRoute
                  path="/tickets"
                  render={props => <Tickets {...props} user={user} />}
                />

                <ProtectedRoute
                  path="/payments/:id"
                  render={props => <PaymentForm {...props} user={user} />}
                />
                <ProtectedRoute
                  path="/payments"
                  render={props => <Payments {...props} user={user} />}
                />

                <ProtectedRoute
                  path="/invoices/:id"
                  render={props => <Invoice360Panel {...props} user={user} />}
                />
                <ProtectedRoute
                  path="/invoices"
                  render={props => <Invoices {...props} user={user} />}
                />

                <ProtectedRoute
                  path="/bonuses/:id"
                  render={props => <Bonus360Panel {...props} user={user} />}
                />
                <ProtectedRoute
                  path="/bonuses"
                  render={props => <Bonuses {...props} user={user} />}
                />

                <Route path="/not-found" component={NotFound} />
                <Redirect to="./home" />
              </Switch>
            </div>
          </div>
          </main>
          { user && <Footer /> }
        </div>
        { user && (
          <HelpDrawer
            appBase="/client"
            getAuthToken={auth.getAccessToken}
            isOpen={this.state.isHelpOpen}
            requestedDocPath={this.state.helpDocPath}
            onClose={this.closeHelp}
          />
        )}
        { user && <PortalAiWidget /> }
      </React.Fragment>
    );
  }
}

export default App;
